"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const RoomOutlined_1 = __importDefault(require("@mui/icons-material/RoomOutlined"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const ProgressiveImage_1 = __importDefault(require("../../../../common/components/Other/ProgressiveImage"));
const helpers_1 = require("../../../../common/helpers/helpers");
const translations_1 = __importDefault(require("../../../../common/translations"));
const Item = styled_components_1.default.div `
  display: flex;
  gap: 20px;
  position: relative;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  border-radius: 10px;
  padding: 5px;
  background-color: white;
`;
const ItemImage = styled_components_1.default.div `
  img {
    border-radius: 10px;
    width: 160px;
  }
`;
const ItemContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  font-size: 20px;
`;
const BookingAndAdditionalActions = styled_components_1.default.div `
  margin-bottom: 5px;
  min-height: 24px;
`;
const PlaceAndTime = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  min-height: 24px;
`;
const Place = styled_components_1.default.div `
  display: flex;
  align-items: center;
  color: #807e7e;

  svg {
    position: relative;
    bottom: 1px;
    height: 70%;
    width: 20px;
    left: -3px;
  }

  p {
    margin: 0px;
    max-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const Time = styled_components_1.default.div `
  text-align: right;
  min-width: 160px;
  flex-shrink: 0;
  color: #807e7e;

  span {
    background-color: #fafafa;
    padding: 3px 8px;
    border-radius: 4px;
  }
`;
const Title = styled_components_1.default.p `
  font-size: clamp(16px, calc(1rem + (24 - 16) * ((100vw - 768px) / (1080 - 768))), 24px);
  min-height: 0vw;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
`;
const ListItem = ({ content, timezone, onListItemClick }) => {
    const renderActivityTime = () => {
        if (content.type === 'activity') {
            const locale = translations_1.default.currentLocale();
            const startTime = helpers_1.Helpers.getHourFromDate(content.start, timezone, locale);
            const endTime = helpers_1.Helpers.getHourFromDate(content.end, timezone, locale);
            const isGermanLocale = locale === null || locale === void 0 ? void 0 : locale.toLowerCase().startsWith('de');
            const startTimeWithSuffix = isGermanLocale ? `${startTime} Uhr` : startTime;
            const endTimeWithSuffix = isGermanLocale ? `${endTime} Uhr` : endTime;
            if (!content.showStartTime && !content.showEndTime) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            return (react_1.default.createElement(Time, { className: "list-item-time right-align grey-text text-lighten-1" },
                content.showStartTime && content.showEndTime && (react_1.default.createElement("span", null,
                    startTime,
                    " - ",
                    endTimeWithSuffix)),
                content.showStartTime && !content.showEndTime && react_1.default.createElement("span", null, startTimeWithSuffix)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    return (react_1.default.createElement(Item, { "data-testid": "list-item", className: "list-item", key: content.id, onClick: () => onListItemClick(content) },
        react_1.default.createElement(ItemImage, { className: "list-item-img-container" },
            react_1.default.createElement(ProgressiveImage_1.default, { image: content.smallImage ? content.smallImage : '/images/other/placeholder.png', alt: content.title })),
        react_1.default.createElement(ItemContent, { className: "list-item-content" },
            react_1.default.createElement(PlaceAndTime, null,
                react_1.default.createElement(Place, null, content.placeName && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(RoomOutlined_1.default, null),
                    react_1.default.createElement("p", null, content.placeName)))),
                (content.type === 'activity' || content.type === 'convention_activity') && (react_1.default.createElement(react_1.default.Fragment, null, renderActivityTime()))),
            react_1.default.createElement(Title, { className: "list-item-title" }, content.title),
            react_1.default.createElement(BookingAndAdditionalActions, { className: "list-item-book-status" }))));
};
exports.ListItem = ListItem;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ListItem));
